const API_BASE_URL = "https://affect-labour-bloom-mere.trycloudflare.com"
 
let currentFacingMode = "environment";
let cropper = null;
let cropperReady = false;
let torchOn = false;
let selectedAlbumFiles = [];
let cameraStream = null;
let visualPasteEnabled = false;


console.log("visual-search.js loaded");

function addGloboCameraSuggestion() {
  const suggestionList = document.querySelector(
    "#gl-listbox .gl-list__content ul"
  );

  if (!suggestionList) return;

  if (
    suggestionList.querySelector(
      ".globo-camera-suggestion-item"
    )
  ) {
    return;
  }

  const suggestionItems =
    suggestionList.querySelectorAll(
      ":scope > li.ui-menu-item"
    );

  if (!suggestionItems.length) return;

  const cameraItem =
    document.createElement("li");

  cameraItem.className =
    "globo-camera-suggestion-item";

  cameraItem.setAttribute(
    "role",
    "presentation"
  );

  const cameraLink =
    document.createElement("button");

  cameraLink.type = "button";

  cameraLink.className =
    "globo-camera-suggestion-button";

  cameraItem.appendChild(cameraLink);

  cameraLink.setAttribute(
    "aria-label",
    "Search using a photo"
  );

  cameraLink.setAttribute(
    "aria-label",
    "Search using a photo"
  );

  cameraLink.innerHTML = `
    <span class="globo-camera-suggestion-content">
      <span class="globo-camera-suggestion-icon">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="
              M9 5
              L10.4 3
              H13.6
              L15 5
              H19
              C20.1 5 21 5.9 21 7
              V18
              C21 19.1 20.1 20 19 20
              H5
              C3.9 20 3 19.1 3 18
              V7
              C3 5.9 3.9 5 5 5
              H9
              Z
            "
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linejoin="round"
          />

          <circle
            cx="12"
            cy="12.5"
            r="3.7"
            stroke="currentColor"
            stroke-width="1.8"
          />
        </svg>
      </span>

      <span class="globo-camera-suggestion-text">
        Search using a photo
      </span>

      <span class="globo-camera-suggestion-arrow">
        ›
      </span>
    </span>
  `;

  function closeGloboAndOpenCamera(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const globoInput =
      document.querySelector(
        "#gl-d-searchbox-input"
      );

    const outerPopup =
      cameraItem.closest(
        "ul.glFilter-search-popup"
      ) ||
      document.querySelector(
        "ul.glFilter-search-popup"
      );

    /*
     * Close Globo through jQuery UI.
     * This is temporary and allows it to reopen.
     */
    if (
      globoInput &&
      window.jQuery
    ) {
      try {
        const $input =
          window.jQuery(globoInput);

        if (
          $input.autocomplete &&
          $input.autocomplete(
            "instance"
          )
        ) {
          $input.autocomplete(
            "close"
          );
        }
      } catch (error) {
        console.log(
          "Globo normal close failed:",
          error
        );
      }
    }

    /*
     * Send Escape directly to the input.
     */
    if (globoInput) {
      globoInput.dispatchEvent(
        new KeyboardEvent("keydown", {
          key: "Escape",
          code: "Escape",
          keyCode: 27,
          which: 27,
          bubbles: true,
          cancelable: true
        })
      );

      globoInput.blur();

      globoInput.setAttribute(
        "readonly",
        "readonly"
      );

      globoInput.setAttribute(
        "tabindex",
        "-1"
      );

      document.body.focus();
    }

    /*
     * Fallback only.
     * Plain display:none can be replaced by Globo
     * when the search bar opens again.
     */
    if (outerPopup) {
      outerPopup.style.display = "none";
      outerPopup.setAttribute(
        "aria-hidden",
        "true"
      );
    }

    setTimeout(function () {
      openVisualSearch();

      setTimeout(function () {
        if (globoInput) {
          globoInput.blur();
        }

        const uploadBox =
          document.getElementById("uploadBox");

        const closeButton =
          uploadBox?.querySelector(
            ".close-upload"
          );

        if (closeButton) {
          closeButton.focus({
            preventScroll: true
          });
        }
      }, 50);
    }, 80);
  }

  [
    "pointerdown",
    "mousedown",
    "touchstart"
  ].forEach(function (eventName) {
    cameraLink.addEventListener(
      eventName,
      function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      },
      true
    );
  });

  cameraLink.addEventListener(
    "click",
    closeGloboAndOpenCamera,
    true
  );

  cameraLink.addEventListener(
    "keydown",
    function (event) {
      if (
        event.key === "Enter" ||
        event.key === " "
      ) {
        closeGloboAndOpenCamera(
          event
        );
      }
    },
    true
  );

  suggestionList.appendChild(
    cameraItem
  );
}

const globoCameraObserver =
  new MutationObserver(
    function () {
      addGloboCameraSuggestion();
    }
  );

globoCameraObserver.observe(
  document.body,
  {
    childList: true,
    subtree: true
  }
);

document.addEventListener(
  "DOMContentLoaded",
  addGloboCameraSuggestion
);

function openVisualSearch() {
  if (window.innerWidth <= 768) {
    openMobileCamera();
    return;
  }

  const uploadBox =
    document.getElementById("uploadBox");

  const overlay =
    document.getElementById(
      "visualSearchOverlay"
    );

  console.log(
    "openVisualSearch desktop",
    uploadBox,
    overlay
  );

  /*
   * Do not enable paste if the visual-search
   * elements do not exist.
   */
  if (!uploadBox) {
    visualPasteEnabled = false;
    return;
  }

  visualPasteEnabled = true;

  if (overlay) {
    document.body.appendChild(overlay);

    overlay.classList.add("is-active");
    overlay.style.display = "block";
    overlay.style.opacity = "1";
    overlay.style.visibility = "visible";
    overlay.style.pointerEvents = "auto";
    overlay.style.zIndex = "2147483646";
  }

  document.body.appendChild(uploadBox);

  uploadBox.style.display = "block";
  uploadBox.style.visibility = "visible";
  uploadBox.style.opacity = "1";
  uploadBox.style.pointerEvents = "auto";
  uploadBox.style.zIndex = "2147483647";
}



async function openMobileCamera() {
  if (document.activeElement) {
    document.activeElement.blur();
  }

  const modal =
    document.getElementById(
      "mobileCameraModal"
    );

  const video =
    document.getElementById(
      "cameraPreview"
    );

  if (!modal || !video) {
    visualPasteEnabled = false;
    return;
  }

  document.body.appendChild(modal);

  modal.style.display = "flex";
  modal.style.zIndex = "2147483647";

  /*
   * Enable paste only after the camera modal
   * has actually opened.
   */
  visualPasteEnabled = true;

  try {
    if (cameraStream) {
      cameraStream
        .getTracks()
        .forEach(track => track.stop());

      cameraStream = null;
    }

    cameraStream =
      await navigator.mediaDevices
        .getUserMedia({
          video: {
            facingMode: {
              ideal: currentFacingMode
            }
          },
          audio: false
        });

    video.srcObject = cameraStream;
    await video.play();

  } catch (err) {
    console.error(
      "Camera error:",
      err
    );

    alert(
      "Cannot open camera. Please choose photo from album."
    );
  }
}

function closeMobileCamera() {
  visualPasteEnabled = false;
  const modal = document.getElementById("mobileCameraModal");
  const video = document.getElementById("cameraPreview");

  if (modal) modal.style.display = "none";

  if (cameraStream) {
    cameraStream.getTracks().forEach(track => track.stop());
    cameraStream = null;
  }

  if (video) video.srcObject = null;
}

function closeUploadBox() {
  visualPasteEnabled = false;
  const uploadBox = document.getElementById("uploadBox");
  const overlay = document.getElementById("visualSearchOverlay");

  if (uploadBox) {
    uploadBox.style.display = "none";
    uploadBox.style.visibility = "hidden";
    uploadBox.style.opacity = "0";
    uploadBox.style.pointerEvents = "none";
  }

  if (overlay) {
    overlay.classList.remove("is-active");
    overlay.style.display = "none";
    overlay.style.opacity = "0";
    overlay.style.visibility = "hidden";
    overlay.style.pointerEvents = "none";
  }

  const globoInput = document.querySelector(
    "#gl-d-searchbox-input"
  );

  if (globoInput) {
    globoInput.removeAttribute("readonly");
    globoInput.removeAttribute("tabindex");
    globoInput.blur();
  }
}

function previewImageSearch(event) {
  const file = event.target.files[0];
  if (!file) return;

  handleImageFile(file);
  event.target.value = "";
}


function initVisualDropArea() {
  const dropArea =
    document.getElementById("dropArea");

  if (!dropArea) return;

  /*
   * Prevent duplicate listeners.
   */
  if (
    dropArea.dataset.dragDropReady ===
    "true"
  ) {
    return;
  }

  dropArea.dataset.dragDropReady =
    "true";

  let dragDepth = 0;

  function stopDragEvent(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  dropArea.addEventListener(
    "dragenter",
    function (event) {
      stopDragEvent(event);

      dragDepth += 1;

      dropArea.classList.add(
        "is-dragging"
      );

      if (event.dataTransfer) {
        event.dataTransfer.dropEffect =
          "copy";
      }
    }
  );

  dropArea.addEventListener(
    "dragover",
    function (event) {
      stopDragEvent(event);

      dropArea.classList.add(
        "is-dragging"
      );

      if (event.dataTransfer) {
        event.dataTransfer.dropEffect =
          "copy";
      }
    }
  );

  dropArea.addEventListener(
    "dragleave",
    function (event) {
      stopDragEvent(event);

      dragDepth = Math.max(
        0,
        dragDepth - 1
      );

      if (dragDepth === 0) {
        dropArea.classList.remove(
          "is-dragging"
        );
      }
    }
  );

  dropArea.addEventListener(
    "drop",
    function (event) {
      stopDragEvent(event);

      dragDepth = 0;

      dropArea.classList.remove(
        "is-dragging"
      );

      const files = Array.from(
        event.dataTransfer?.files || []
      );

      const imageFile =
        files.find(function (file) {
          return (
            file.type &&
            file.type.startsWith(
              "image/"
            )
          );
        });

      if (!imageFile) {
        alert(
          "Please drop an image file."
        );

        return;
      }

      handleImageFile(imageFile);
    }
  );
}

function formatMetafieldLabel(key) {
  if (!key) return "";

  return key
    .replace(/^custom\./, "")
    .replace(/^shopify\./, "")
    .replace(/[-_]/g, " ")
    .replace(/\b\w/g, char => char.toUpperCase());
}

function renderVisibleAttributes(product) {
  const visibleAttributes =
    product.visible_attributes || {};

  const entries = Object.entries(
    visibleAttributes
  ).filter(([, value]) => {
    return (
      value !== null &&
      value !== undefined &&
      String(value).trim() !== ""
    );
  });

  if (!entries.length) {
    return "";
  }

  return entries.map(
    ([key, value]) => `
      <span>
        <strong>
          ${escapeVisualHTML(
            formatMetafieldLabel(key)
          )}:
        </strong>

        ${escapeVisualHTML(value)}
      </span>
    `
  ).join("");
}

let currentVisualFilterState = null;
let visualFilterRequestController = null;
let visualFilterRequestNumber = 0;


function splitVisualMetafieldValue(value) {
  if (
    value === null ||
    value === undefined
  ) {
    return [];
  }

  return String(value)
    .replace(/[\/|&;]/g, ",")
    .split(",")
    .map(item => item.trim())
    .filter(Boolean);
}


function getInitialVisualFilterValue(
  product,
  field
) {
  const rawValue =
    product.visible_attributes?.[field] ??
    "";

  const parts = splitVisualMetafieldValue(
    rawValue
  );

  return parts[0] || "";
}


function escapeVisualHTML(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

function formatFilterName(key) {
  return formatMetafieldLabel(key);
}

function buildVisualFilterPanel(data) {
  const detection =
    data.uploaded_image_detection || {};

  const workflow =
    detection.workflow || {};

  const isWorkflowSearch =
    detection.source ===
    "clip_plus_workflow";

  const isNoResultSuggestion =
    detection.source ===
    "no_result_suggestions";

  if (
    !isWorkflowSearch &&
    !isNoResultSuggestion
  ) {
    currentVisualFilterState = null;
    return "";
  }

  if (
    !workflow ||
    !workflow.workflow_name ||
    workflow.workflow_name ===
      "No workflow matched"
  ) {
    currentVisualFilterState = null;
    return "";
  }

  const results = data.results || [];
  const topProduct = results[0] || {};

  const workflowTargets =
    topProduct.workflow_targets ||
    workflow.targets ||
    [];

  /*
   * IMPORTANT:
   * Only visible_fields are displayed.
   * matching_fields may affect backend scoring,
   * but hidden matching fields must not become
   * result-page filters.
   */
  const visibleFields = [
    ...new Set(
      detection.visible_fields || []
    )
  ];

  if (!visibleFields.length) {
    currentVisualFilterState = null;
    return "";
  }

  const selectedFilters = {};

  visibleFields.forEach(field => {
    selectedFilters[field] =
      getInitialVisualFilterValue(
        topProduct,
        field
      );
  });

  const firstTarget =
    workflowTargets[0] || {};

  const primaryIdentifier =
    firstTarget.identifier ||
    workflow.identifier ||
    "Category";

  const primaryValue =
    firstTarget.target_value ||
    workflow.target_value ||
    "";

  const baseScores = {};

  results.forEach(product => {
    if (!product.sku) return;

    baseScores[product.sku] =
      Number(
        product.clip_score ??
        product.score ??
        0
      );
  });

  currentVisualFilterState = {
    primary_identifier:
      primaryIdentifier,

    primary_value:
      primaryValue,

    workflow_targets:
      workflowTargets,

    filter_fields:
      visibleFields,

    selected_filters:
      selectedFilters,

    base_scores:
      baseScores
  };

  return `
    <div
      class="visual-filter-panel"
      id="visualFilterPanel"
    >
      <label
        class="visual-filter-chip primary-filter"
      >
        <strong>
          ${escapeVisualHTML(primaryIdentifier)}:
        </strong>

        <div
          class="visual-custom-select visual-primary-select"
          data-primary="1"
        >
          <button
            type="button"
            class="visual-custom-select-btn"
          >
            <span>
              ${escapeVisualHTML(primaryValue)}
            </span>
            <b>⌄</b>
          </button>

          <div
            class="visual-custom-options"
          ></div>
        </div>
      </label>

      ${visibleFields.map(field => `
        <label class="visual-filter-chip">
          <strong>
            ${escapeVisualHTML(
              formatFilterName(field)
            )}:
          </strong>

          <div
            class="visual-custom-select"
            data-field="${escapeVisualHTML(field)}"
          >
            <button
              type="button"
              class="visual-custom-select-btn"
            >
              <span>
                ${escapeVisualHTML(
                  selectedFilters[field] || "Any"
                )}
              </span>
              <b>⌄</b>
            </button>

            <div
              class="visual-custom-options"
            ></div>
          </div>
        </label>
      `).join("")}
    </div>
  `;
}


function trackVisualProductClick() {
  const endpoint = `${API_BASE_URL}/track-product-click`;

  if (navigator.sendBeacon) {
    const sent = navigator.sendBeacon(
      endpoint,
      new Blob(["click"], {
        type: "text/plain;charset=UTF-8"
      })
    );

    if (sent) return;
  }

  fetch(endpoint, {
    method: "POST",
    body: "click",
    keepalive: true
  }).catch(error => {
    console.error("Product click tracking failed:", error);
  });
}


document.addEventListener("click", function (event) {
  const card = event.target.closest(".visual-result-card");

  if (!card) return;

  trackVisualProductClick(card);
});


function showVisualResults(data) {
  
  const resultsBox = document.getElementById("visualSearchResults");
  const resultsOverlay = document.getElementById("visualResultsOverlay");
  const detectionBox = document.getElementById("visualDetectionBox");
  const grid = document.getElementById("visualResultsGrid");

  const results = data.results || [];
  const detection = data.uploaded_image_detection || {};
  const workflow = detection.workflow || {};
  const topProduct = results[0] || {};

  const isWorkflowSearch = detection.source === "clip_plus_workflow";
  const isFallbackSearch = detection.source === "fallback_old_default";
  const isNoResultSuggestion = detection.source === "no_result_suggestions";
  const topVisibleAttributes = renderVisibleAttributes(topProduct);

  if (detectionBox) {
    if (isNoResultSuggestion) {
      detectionBox.innerHTML = `
        <div class="no-result-anim">
          <div class="sad-face">☹</div>
          <div class="search-icon">
            <span>?</span>
          </div>
        </div>

        <div class="visual-no-results-message">
          <p><strong>Sorry, no exact match was found.</strong></p>
          <p>Do you mean one of these?</p>
        </div>

        ${buildVisualFilterPanel(data)}
      `;

      loadVisualFilterOptions();

    } else if (isWorkflowSearch) {
      detectionBox.innerHTML = buildVisualFilterPanel(data);
      loadVisualFilterOptions();

    } else {
      detectionBox.innerHTML = `
        <div class="visual-detection-tags">
          <span><strong>Detected:</strong> ${detection.category || "Unknown"}</span>
          <span><strong>Product Type:</strong> ${detection.product_type || "Unknown"}</span>
          <span><strong>Colour:</strong> ${detection.colour || "Unknown"}</span>
          <span><strong>Mounting:</strong> ${detection.mounting_type || "Unknown"}</span>
        </div>
        ${isFallbackSearch ? `<p><small>Using default search because no workflow matched.</small></p>` : ""}
      `;
    }
  }

  if (grid) {
    if (!results.length) {
      grid.innerHTML = `
        <div class="visual-no-results">
          <p>No matching product found.</p>
        </div>
      `;
    } else {
      if (isNoResultSuggestion) {
        const slides = [];

        for (let i = 0; i < results.length; i += 4) {
          slides.push(results.slice(i, i + 4));
        }

        grid.innerHTML = `
          <div class="sorry-carousel">
            <button type="button" class="sorry-carousel-arrow sorry-carousel-prev" id="sorryCarouselPrev">‹</button>
            <button type="button" class="sorry-carousel-arrow sorry-carousel-next" id="sorryCarouselNext">›</button>
            <div class="sorry-carousel-track" id="sorryCarouselTrack">
              ${slides.map(slide => `
                <div class="sorry-carousel-slide">
                  ${slide.map(product => `
                    <a href="${product.url}" class="visual-result-card visual-sorry-card">
                      <div class="visual-result-image-wrap">
                        <img class="visual-result-img visual-result-img-main"
                          src="${product.image}"
                          loading="eager">

                        ${product.image2 ? `
                          <img class="visual-result-img visual-result-img-hover"
                            src="${product.image2}"
                            loading="lazy">
                        ` : ""}
                      </div>

                      <h3>${product.title}</h3>
                    </a>
                  `).join("")}
                </div>
              `).join("")}
            </div>

            <div class="sorry-carousel-dots">
              ${slides.map((_, index) => `
                <button type="button" class="sorry-dot ${index === 0 ? "is-active" : ""}" data-slide="${index}"></button>
              `).join("")}
            </div>
          </div>
        `;

        startSorryCarousel(slides.length);
      } else {
          grid.innerHTML = results.map(product => `
            <a
              href="${escapeVisualHTML(product.url)}"
              class="visual-result-card"
            >
              <div class="visual-result-image-wrap">
                <img
                  class="visual-result-img visual-result-img-main"
                  src="${escapeVisualHTML(product.image)}"
                  loading="eager"
                  alt="${escapeVisualHTML(product.title)}"
                >

                ${product.image2 ? `
                  <img
                    class="visual-result-img visual-result-img-hover"
                    src="${escapeVisualHTML(product.image2)}"
                    loading="lazy"
                    alt=""
                  >
                ` : ""}
              </div>

              <h3>
                ${escapeVisualHTML(product.title)}
              </h3>
            </a>
          `).join("");
      }
    }
  }

  if (resultsOverlay) {
    document.body.appendChild(resultsOverlay);
    resultsOverlay.classList.add("is-active");
    resultsOverlay.style.display = "block";
    resultsOverlay.style.opacity = "1";
    resultsOverlay.style.visibility = "visible";
    resultsOverlay.style.pointerEvents = "auto";
    resultsOverlay.style.zIndex = "2147483646";
  }

  if (resultsBox) {
    document.body.appendChild(resultsBox);
    resultsBox.style.display = "block";
    resultsBox.style.opacity = "1";
    resultsBox.style.visibility = "visible";
    resultsBox.style.pointerEvents = "auto";
    resultsBox.style.zIndex = "2147483647";
  }
}


async function loadVisualFilterOptions(
  suppliedData = null
) {
  if (!currentVisualFilterState) {
    return;
  }

  let data = suppliedData;

  if (!data) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/filter-visual-results`,
        {
          method: "POST",
          headers: {
            "Content-Type":
              "application/json"
          },
          body: JSON.stringify(
            currentVisualFilterState
          )
        }
      );

      if (!response.ok) {
        console.error(
          "Filter option error:",
          await response.text()
        );

        return;
      }

      data = await response.json();

    } catch (error) {
      console.error(
        "Filter option request failed:",
        error
      );

      return;
    }
  }

  const options = data.options || {};

  /*
   * Backend is the source of truth for which
   * workflow fields are visible.
   */
  if (
    Array.isArray(data.filter_fields)
  ) {
    currentVisualFilterState.filter_fields =
      data.filter_fields;
  }

  if (
    data.selected_filters &&
    typeof data.selected_filters === "object"
  ) {
    currentVisualFilterState.selected_filters = {
      ...currentVisualFilterState
        .selected_filters,
      ...data.selected_filters
    };
  }

  function attachOptionHandlers(
    dropdown,
    menu,
    onPick
  ) {
    menu
      .querySelectorAll(
        "button[data-value]"
      )
      .forEach(option => {
        option.onclick =
          async function (event) {
            event.preventDefault();
            event.stopPropagation();

            dropdown.classList.remove(
              "is-open"
            );

            await onPick(
              this.dataset.value ?? ""
            );
          };
      });
  }


  function renderDropdownOptions(
    dropdown,
    values,
    currentValue,
    onPick,
    searchText = ""
  ) {
    const menu = dropdown.querySelector(
      ".visual-custom-options"
    );

    if (!menu) return;

    const normalizedSearch =
      String(searchText)
        .trim()
        .toLowerCase();

    const cleanValues = [
      ...new Set(
        (values || [])
          .map(value =>
            String(value).trim()
          )
          .filter(Boolean)
      )
    ];

    const filteredValues =
      normalizedSearch
        ? cleanValues.filter(value =>
            value
              .toLowerCase()
              .startsWith(
                normalizedSearch
              )
          )
        : cleanValues;

    menu.innerHTML = `
      <button
        type="button"
        class="${
          !currentValue
            ? "is-selected"
            : ""
        }"
        data-value=""
      >
        Any
      </button>

      ${filteredValues.map(value => `
        <button
          type="button"
          class="${
            value === currentValue
              ? "is-selected"
              : ""
          }"
          data-value="${escapeVisualHTML(value)}"
        >
          ${escapeVisualHTML(value)}
        </button>
      `).join("")}
    `;

    attachOptionHandlers(
      dropdown,
      menu,
      onPick
    );
  }


  function setupDropdown(
    dropdown,
    values,
    currentValue,
    onPick
  ) {
    const button = dropdown.querySelector(
      ".visual-custom-select-btn"
    );

    const label = button?.querySelector(
      "span"
    );

    if (!button || !label) return;

    label.textContent =
      currentValue || "Any";

    renderDropdownOptions(
      dropdown,
      values,
      currentValue,
      onPick
    );

    let searchText = "";
    let searchTimer = null;

    dropdown.onkeydown =
      function (event) {
        if (
          !dropdown.classList.contains(
            "is-open"
          )
        ) {
          return;
        }

        if (
          event.key === "Backspace"
        ) {
          searchText =
            searchText.slice(0, -1);

        } else if (
          event.key.length === 1
        ) {
          searchText +=
            event.key.toLowerCase();

        } else {
          return;
        }

        clearTimeout(searchTimer);

        searchTimer = setTimeout(
          function () {
            searchText = "";
          },
          900
        );

        renderDropdownOptions(
          dropdown,
          values,
          currentValue,
          onPick,
          searchText
        );
      };

    button.onclick =
      function (event) {
        event.preventDefault();
        event.stopPropagation();

        document
          .querySelectorAll(
            ".visual-custom-select.is-open"
          )
          .forEach(element => {
            if (element !== dropdown) {
              element.classList.remove(
                "is-open"
              );
            }
          });

        dropdown.classList.toggle(
          "is-open"
        );

        dropdown.setAttribute(
          "tabindex",
          "0"
        );

        dropdown.focus();
      };
  }


  const primaryDropdown =
    document.querySelector(
      ".visual-primary-select"
    );

  if (primaryDropdown) {
    const button =
      primaryDropdown.querySelector(
        ".visual-custom-select-btn"
      );

    const label =
      button?.querySelector("span");

    const arrow =
      button?.querySelector("b");

    if (label) {
      label.textContent =
        currentVisualFilterState
          .primary_value || "";
    }

    if (arrow) {
      arrow.style.display = "none";
    }

    if (button) {
      button.disabled = true;
      button.style.cursor = "default";
      button.style.pointerEvents =
        "none";
    }

    primaryDropdown.classList.remove(
      "is-open"
    );

    const menu =
      primaryDropdown.querySelector(
        ".visual-custom-options"
      );

    if (menu) {
      menu.innerHTML = "";
      menu.style.display = "none";
    }
  }

  document
    .querySelectorAll(
      ".visual-custom-select[data-field]"
    )
    .forEach(dropdown => {
      const field =
        dropdown.dataset.field;

      /*
       * Ignore any stale HTML filter that is no
       * longer allowed by visible_fields.
       */
      if (
        !currentVisualFilterState
          .filter_fields
          .includes(field)
      ) {
        dropdown
          .closest(
            ".visual-filter-chip"
          )
          ?.remove();

        return;
      }

      const currentValue =
        currentVisualFilterState
          .selected_filters[field] || "";

      const values =
        options[field] || [];

      setupDropdown(
        dropdown,
        values,
        currentValue,
        async function (value) {
          currentVisualFilterState
            .selected_filters[field] =
              value;

          await refreshVisualFilteredResults();
        }
      );
    });

  document.onclick =
    function () {
      document
        .querySelectorAll(
          ".visual-custom-select.is-open"
        )
        .forEach(element => {
          element.classList.remove(
            "is-open"
          );
        });
    };
}

async function refreshVisualFilteredResults() {
  if (!currentVisualFilterState) {
    return;
  }

  const grid = document.getElementById(
    "visualResultsGrid"
  );

  const requestNumber =
    ++visualFilterRequestNumber;

  /*
   * Cancel the previous filter request.
   * This prevents an older Chrome response from
   * arriving after the newer Black response and
   * replacing the correct result grid.
   */
  if (visualFilterRequestController) {
    visualFilterRequestController.abort();
  }

  visualFilterRequestController =
    new AbortController();

  if (grid) {
    grid.innerHTML = `
      <p style="padding:20px;">
        Filtering...
      </p>
    `;
  }

  try {
    const response = await fetch(
      `${API_BASE_URL}/filter-visual-results`,
      {
        method: "POST",
        headers: {
          "Content-Type":
            "application/json"
        },
        body: JSON.stringify(
          currentVisualFilterState
        ),
        signal:
          visualFilterRequestController
            .signal
      }
    );

    if (!response.ok) {
      console.error(
        "Filter backend error:",
        await response.text()
      );

      return;
    }

    const data = await response.json();

    /*
     * Ignore an outdated response even if the
     * browser failed to cancel it in time.
     */
    if (
      requestNumber !==
      visualFilterRequestNumber
    ) {
      return;
    }

    if (
      Array.isArray(data.filter_fields)
    ) {
      currentVisualFilterState
        .filter_fields =
          data.filter_fields;
    }

    if (
      data.selected_filters &&
      typeof data.selected_filters ===
        "object"
    ) {
      currentVisualFilterState
        .selected_filters = {
          ...currentVisualFilterState
            .selected_filters,
          ...data.selected_filters
        };
    }

    const results = data.results || [];

    if (!grid) return;

    if (!results.length) {
      grid.innerHTML = `
        <div
          class="visual-no-results visual-filter-empty"
        >
          <div class="no-result-anim">
            <div class="sad-face">
              ☹
            </div>

            <div class="search-icon">
              <span>?</span>
            </div>
          </div>

          <div
            class="visual-no-results-message"
          >
            <p>
              <strong>
                No product found.
              </strong>
            </p>

            <p>
              No product matches the
              selected filters.
            </p>
          </div>
        </div>
      `;

    } else {
      grid.innerHTML =
        results.map(product => `
          <a
            href="${escapeVisualHTML(
              product.url
            )}"
            class="visual-result-card"
          >
            <div
              class="visual-result-image-wrap"
            >
              <img
                class="visual-result-img visual-result-img-main"
                src="${escapeVisualHTML(
                  product.image
                )}"
                loading="eager"
                alt="${escapeVisualHTML(
                  product.title
                )}"
              >

              ${product.image2 ? `
                <img
                  class="visual-result-img visual-result-img-hover"
                  src="${escapeVisualHTML(
                    product.image2
                  )}"
                  loading="lazy"
                  alt=""
                >
              ` : ""}
            </div>

            <h3>
              ${escapeVisualHTML(
                product.title
              )}
            </h3>

            ${renderVisibleAttributes(
              product
            )}
          </a>
        `).join("");
    }

    /*
     * Rebuild dropdowns using the same response.
     * Do not make another unnecessary request.
     */
    await loadVisualFilterOptions(data);

  } catch (error) {
    if (
      error.name === "AbortError"
    ) {
      return;
    }

    console.error(
      "Filter request failed:",
      error
    );

    if (grid) {
      grid.innerHTML = `
        <div
          class="visual-no-results visual-filter-empty"
        >
          <p>
            Filter request failed.
          </p>
        </div>
      `;
    }
  }
}
//function injectGloboMobileLensButton() {
//  const globoInput = document.querySelector("#gl-d-searchbox-input");

//  if (!globoInput) return;

//  const inputParent = globoInput.parentElement;
//  if (!inputParent) return;

//  if (inputParent.querySelector(".globo-mobile-lens-btn")) return;

//  const btn = document.createElement("button");
//  btn.type = "button";
//  btn.className = "globo-mobile-lens-btn";
//  btn.setAttribute("aria-label", "Visual Search");

//  btn.innerHTML = `
//    <img
//      src="/cdn/shop/t/9/assets/camera-icon.png"
//      alt=""
//      class="globo-lens-icon"
//     width="28"
//      height="28">
//  `;

//   btn.addEventListener("pointerdown", function (event) {
//     event.preventDefault();
//     event.stopPropagation();
//     event.stopImmediatePropagation();
//     console.log("GLOBO CAMERA CLICKED");

//     openVisualSearch();
//   }, true);

//   btn.addEventListener("click", function (event) {
//     event.preventDefault();
//     event.stopPropagation();
//     event.stopImmediatePropagation();
//   }, true);

//   inputParent.appendChild(btn);
// }

// document.addEventListener("DOMContentLoaded", injectGloboMobileLensButton);

// const globoLensObserver = new MutationObserver(injectGloboMobileLensButton);

// globoLensObserver.observe(document.body, {
//   childList: true,
//   subtree: true
// });

function enableGloboSearchIcon() {
  const input = document.querySelector("#gl-d-searchbox-input");

  if (!input) return;

  const inputParent = input.parentElement;
  if (!inputParent) return;

  /*
   * Finds the search icon shown on the left side
   * of the Globo search input.
   */
  const searchIcon =
    inputParent.querySelector("svg") ||
    inputParent.querySelector("img");

  if (!searchIcon) return;

  /*
   * Prevent adding the click event repeatedly.
   */
  if (searchIcon.dataset.searchClickReady === "true") {
    return;
  }

  searchIcon.dataset.searchClickReady = "true";
  searchIcon.style.cursor = "pointer";

  searchIcon.addEventListener("click", function (event) {
    event.preventDefault();
    event.stopPropagation();

    const searchValue = input.value.trim();

    if (!searchValue) {
      input.focus();
      return;
    }

    const form = input.closest("form");

    if (form) {
      /*
       * Uses the same search form as pressing Enter.
       */
      if (typeof form.requestSubmit === "function") {
        form.requestSubmit();
      } else {
        form.submit();
      }

      return;
    }

    /*
     * Backup: simulate pressing Enter.
     */
    input.dispatchEvent(
      new KeyboardEvent("keydown", {
        key: "Enter",
        code: "Enter",
        keyCode: 13,
        which: 13,
        bubbles: true
      })
    );
  });
}

document.addEventListener(
  "DOMContentLoaded",
  enableGloboSearchIcon
);

const globoSearchIconObserver =
  new MutationObserver(enableGloboSearchIcon);

globoSearchIconObserver.observe(document.body, {
  childList: true,
  subtree: true
});

let sorryCarouselTimer = null;

function startSorryCarousel(totalSlides) {
  if (sorryCarouselTimer) {
    clearInterval(sorryCarouselTimer);
    sorryCarouselTimer = null;
  }

  if (totalSlides <= 1) return;

  let currentSlide = 0;
  const track = document.getElementById("sorryCarouselTrack");
  const dots = document.querySelectorAll(".sorry-dot");
  const prevBtn = document.getElementById("sorryCarouselPrev");
  const nextBtn = document.getElementById("sorryCarouselNext");

  let touchStartX = 0;
  let touchEndX = 0;
  let isSwiping = false;

  function goToSlide(index) {
    if (!track) return;

    currentSlide = (index + totalSlides) % totalSlides;
    track.style.transform = `translateX(-${currentSlide * 100}%)`;

    dots.forEach(dot => dot.classList.remove("is-active"));
    if (dots[currentSlide]) dots[currentSlide].classList.add("is-active");
  }

  function restartTimer() {
    if (sorryCarouselTimer) clearInterval(sorryCarouselTimer);

    sorryCarouselTimer = setInterval(() => {
      goToSlide(currentSlide + 1);
    }, 4000);
  }

  dots.forEach(dot => {
    dot.addEventListener("click", function () {
      goToSlide(Number(this.dataset.slide));
      restartTimer();
    });
  });

  if (prevBtn) {
    prevBtn.onclick = function () {
      goToSlide(currentSlide - 1);
      restartTimer();
    };
  }

  if (nextBtn) {
    nextBtn.onclick = function () {
      goToSlide(currentSlide + 1);
      restartTimer();
    };
  }

  if (track) {
    track.addEventListener(
      "touchstart",
      function (event) {
        touchStartX = event.touches[0].clientX;
        touchEndX = touchStartX;
        isSwiping = true;

        if (sorryCarouselTimer) {
          clearInterval(sorryCarouselTimer);
          sorryCarouselTimer = null;
        }
      },
      { passive: true }
    );

    track.addEventListener(
      "touchmove",
      function (event) {
        if (!isSwiping) return;

        touchEndX = event.touches[0].clientX;
      },
      { passive: true }
    );

    track.addEventListener(
      "touchend",
      function () {
        if (!isSwiping) return;

        const swipeDistance =
          touchEndX - touchStartX;

        const minimumSwipeDistance = 50;

        if (
          swipeDistance <=
          -minimumSwipeDistance
        ) {
          goToSlide(currentSlide + 1);
        } else if (
          swipeDistance >=
          minimumSwipeDistance
        ) {
          goToSlide(currentSlide - 1);
        }

        isSwiping = false;
        touchStartX = 0;
        touchEndX = 0;

        restartTimer();
      },
      { passive: true }
    );

    track.addEventListener(
      "touchcancel",
      function () {
        isSwiping = false;
        restartTimer();
      },
      { passive: true }
    );
  }


  restartTimer();
}

function handleImageFile(file) {
  closeUploadBox();
  closeMobileSearchDrawer();

  if (typeof closeMobileCamera === "function") {
    closeMobileCamera();
  }

  openCropModal(file);
}

function backToVisualUpload() {
  const resultsBox = document.getElementById("visualSearchResults");
  const resultsOverlay = document.getElementById("visualResultsOverlay");

  const uploadBox = document.getElementById("uploadBox");
  const uploadOverlay = document.getElementById("visualSearchOverlay");

  // Close results.
  if (resultsBox) {
    resultsBox.style.display = "none";
    resultsBox.style.opacity = "0";
    resultsBox.style.visibility = "hidden";
    resultsBox.style.pointerEvents = "none";
  }

  if (resultsOverlay) {
    resultsOverlay.classList.remove("is-active");
    resultsOverlay.style.display = "none";
    resultsOverlay.style.opacity = "0";
    resultsOverlay.style.visibility = "hidden";
    resultsOverlay.style.pointerEvents = "none";
  }

  // Reopen upload overlay.
  if (uploadOverlay) {
    document.body.appendChild(uploadOverlay);

    uploadOverlay.classList.add("is-active");
    uploadOverlay.style.display = "block";
    uploadOverlay.style.opacity = "1";
    uploadOverlay.style.visibility = "visible";
    uploadOverlay.style.pointerEvents = "auto";
    uploadOverlay.style.zIndex = "2147483646";
  }

  // Reopen upload panel.
  if (uploadBox) {
    document.body.appendChild(uploadBox);

    uploadBox.style.display = "block";
    uploadBox.style.opacity = "1";
    uploadBox.style.visibility = "visible";
    uploadBox.style.pointerEvents = "auto";
    uploadBox.style.zIndex = "2147483647";
  }
}

function openCropModal(file) {
  const cropModal = document.getElementById("cropModal");
  const cropImage = document.getElementById("cropImage");

  if (!cropModal || !cropImage) {
    console.error("Crop modal or crop image missing");
    return;
  }

  cropperReady = false;

  document.documentElement.classList.add("crop-scroll-locked");
  document.body.classList.add("crop-scroll-locked");

  document.body.appendChild(cropModal);

  cropModal.style.display = "flex";
  cropModal.style.visibility = "visible";
  cropModal.style.opacity = "1";
  cropModal.style.pointerEvents = "auto";
  cropModal.style.zIndex = "2147483647";

  if (cropper) {
    cropper.destroy();
    cropper = null;
  }

  cropImage.onload = null;
  cropImage.removeAttribute("src");

  const imageUrl = URL.createObjectURL(file);

  cropImage.onload = function () {
    cropper = new Cropper(cropImage, {
      viewMode: 1,
      autoCropArea: 0.9,

      movable: true,
      zoomable: true,
      scalable: false,
      rotatable: false,
      responsive: true,
      background: false,

      cropBoxMovable: true,
      cropBoxResizable: true,

      aspectRatio: NaN,

      guides: true,
      center: false,
      highlight: false,

      toggleDragModeOnDblclick: false,

      ready: async function () {
        cropperReady = true;

        cropModal.classList.remove(
          "is-cropping"
        );

        console.log("Cropper ready");

        URL.revokeObjectURL(imageUrl);

        await autoDetectCrop(file);
      },

      cropstart: function () {
        cropModal.classList.add(
          "is-cropping"
        );
      },

      cropmove: function () {
        cropModal.classList.add(
          "is-cropping"
        );
      },

      cropend: function () {
        cropModal.classList.remove(
          "is-cropping"
        );
      }
    });
   };
  cropImage.src = imageUrl;
}

async function autoDetectCrop(file) {
  if (!cropper || !cropperReady) return;

  const formData = new FormData();
  formData.append("image", file);

  try {
    const response = await fetch(`${API_BASE_URL}/detect-crop`, {
      method: "POST",
      body: formData
    });

    if (!response.ok) {
      console.error("Auto crop backend error:", await response.text());
      return;
    }

    const box = await response.json();

    setTimeout(() => {
      if (!cropper || !cropperReady) return;

    const imageData = cropper.getImageData();

    let cropBox = {
      x: Number(box.x),
      y: Number(box.y),
      width: Number(box.width),
      height: Number(box.height)
    };

    if (
      !cropBox.width ||
      !cropBox.height ||
      cropBox.width < imageData.naturalWidth * 0.25 ||
      cropBox.height < imageData.naturalHeight * 0.25
    ) {
      cropBox = {
        x: imageData.naturalWidth * 0.05,
        y: imageData.naturalHeight * 0.05,
        width: imageData.naturalWidth * 0.9,
        height: imageData.naturalHeight * 0.9
      };
    }

    cropper.setData(cropBox);

      console.log("YOLO crop applied:", box);
    }, 300);
  } catch (err) {
    console.error("Auto crop failed:", err);
  }
}

function closeCropModal() {
  document.documentElement.classList.remove("crop-scroll-locked");
  document.body.classList.remove("crop-scroll-locked");
  const cropModal = document.getElementById("cropModal");
  const cropImage = document.getElementById("cropImage");

  if (cropModal) cropModal.style.display = "none";

  cropperReady = false;

  if (cropper) {
    cropper.destroy();
    cropper = null;
  }

  if (cropImage) {
    cropImage.onload = null;
    cropImage.removeAttribute("src");
  }
}

async function searchCroppedImage() {
  if (!cropper || !cropperReady) {
    alert("Cropper not ready yet. Please wait 1 second.");
    return;
  }

  const button = document.querySelector(".crop-search-btn");

  if (button) {
    button.disabled = true;
    button.innerText = "Searching...";
  }

  const canvas = cropper.getCroppedCanvas({
    maxWidth: 1200,
    maxHeight: 1200,
    imageSmoothingEnabled: true,
    imageSmoothingQuality: "high"
  });

  if (!canvas) {
    alert("Cannot crop image. Please close and try again.");

    if (button) {
      button.disabled = false;
      button.innerText = "Search This Area";
    }

    return;
  }

  canvas.toBlob(async function (blob) {
    try {
      const formData = new FormData();
      formData.append("image", blob, "cropped-image.png");

      const response = await fetch(`${API_BASE_URL}/search-image`, {
        method: "POST",
        body: formData
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("REAL BACKEND ERROR:", errorText);
        alert(errorText);
        return;
      }

      const data = await response.json();
      console.log("Search result:", data);

showVisualResults(data);
closeCropModal();

    } catch (err) {
      console.error("Search failed:", err);
      alert("Search failed.");
    } finally {
      if (button) {
        button.disabled = false;
        button.innerText = "Search This Area";
      }
    }
  }, "image/png");
}




function closeVisualResults() {
  const resultsBox = document.getElementById("visualSearchResults");
  const resultsOverlay = document.getElementById("visualResultsOverlay");

  if (resultsBox) {
    resultsBox.style.display = "none";
  }

  if (resultsOverlay) {
    resultsOverlay.classList.remove("is-active");
    resultsOverlay.style.display = "none";
  }
}
window.closeVisualResults = closeVisualResults;

document.addEventListener("paste", function (event) {
  /*
   * Pasting images is allowed only after the
   * camera/visual-search panel was explicitly opened.
   */
  if (!visualPasteEnabled) {
    return;
  }

  if (!event.clipboardData) {
    return;
  }

  const items = Array.from(
    event.clipboardData.items || []
  );

  const imageItem = items.find(function (item) {
    return (
      item.kind === "file" &&
      item.type &&
      item.type.startsWith("image/")
    );
  });

  if (!imageItem) {
    return;
  }

  const file = imageItem.getAsFile();

  if (!file) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  /*
   * Disable immediately so the same paste cannot
   * trigger the visual search more than once.
   */
  visualPasteEnabled = false;

  handleImageFile(file);
});

document.addEventListener("DOMContentLoaded", function () {

  initVisualDropArea();
  const captureButton = document.getElementById("captureButton");
  const flipCameraButton = document.getElementById("flipCameraButton");
  const flashButton = document.getElementById("flashButton");
  const openGalleryButton = document.getElementById("openGalleryButton");
  const chooseAlbumButton = document.getElementById("chooseAlbumButton");
  const mobileGalleryInput = document.getElementById("mobileGalleryInput");
  const mobileAlbumGrid = document.getElementById("mobileAlbumGrid");

  function renderMobileAlbum() {
    if (!mobileAlbumGrid) return;

    mobileAlbumGrid.innerHTML = "";

    if (selectedAlbumFiles.length === 0) {
      mobileAlbumGrid.innerHTML = `
        <div class="no-photo-text">No photos selected</div>
      `;
      return;
    }

    selectedAlbumFiles.forEach(function (file, index) {
      const wrap = document.createElement("div");
      wrap.className = "mobile-album-thumb-wrap";

      const img = document.createElement("img");
      img.className = "mobile-album-thumb";
      img.src = URL.createObjectURL(file);

      img.onclick = function () {
        handleImageFile(file);
      };

      const del = document.createElement("button");
      del.className = "mobile-album-delete";
      del.innerHTML = "×";

      del.onclick = function (e) {
        e.stopPropagation();
        selectedAlbumFiles.splice(index, 1);
        renderMobileAlbum();
      };

      wrap.appendChild(img);
      wrap.appendChild(del);
      mobileAlbumGrid.appendChild(wrap);
    });
  }

  renderMobileAlbum();

  window.renderMobileAlbum = renderMobileAlbum;

  if (captureButton) {
    captureButton.onclick = function () {
      const video = document.getElementById("cameraPreview");

      if (!video || !video.videoWidth || !video.videoHeight) {
        alert("Camera not ready yet.");
        return;
      }

      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      canvas.getContext("2d").drawImage(video, 0, 0);

      canvas.toBlob(function (blob) {
        if (!blob) {
          alert("Cannot capture image.");
          return;
        }

        const file = new File([blob], "camera-capture.jpg", {
          type: "image/jpeg"
        });

        selectedAlbumFiles.unshift(file);
        renderMobileAlbum();

        handleImageFile(file);
      }, "image/jpeg");
    };
  }

  function openAlbumPicker() {
    if (!mobileGalleryInput) return;
    mobileGalleryInput.value = "";
    mobileGalleryInput.click();
  }

  if (openGalleryButton) openGalleryButton.onclick = openAlbumPicker;
  if (chooseAlbumButton) chooseAlbumButton.onclick = openAlbumPicker;

  if (mobileGalleryInput) {
    mobileGalleryInput.onchange = function (event) {
      const newFiles = Array.from(event.target.files || []);
      if (!newFiles.length) return;

      selectedAlbumFiles = selectedAlbumFiles.concat(newFiles);
      renderMobileAlbum();

      mobileGalleryInput.value = "";

      setTimeout(function () {
        handleImageFile(newFiles[0]);
      }, 350);
    };
  }

  if (flipCameraButton) {
    flipCameraButton.onclick = async function () {
      currentFacingMode = currentFacingMode === "environment" ? "user" : "environment";
      document.activeElement?.blur();
      await openMobileCamera();
    };
  }

  if (flashButton) {
    flashButton.onclick = async function () {
      if (!cameraStream) return;

      const track = cameraStream.getVideoTracks()[0];
      const capabilities = track.getCapabilities();

      if (!capabilities.torch) {
        alert("Flash not supported on this device/browser.");
        return;
      }

      torchOn = !torchOn;

      await track.applyConstraints({
        advanced: [{ torch: torchOn }]
      });

      flashButton.classList.toggle("flash-on", torchOn);
    };
  }
});

function closeMobileSearchDrawer() {
  const drawer = document.getElementById("br-mobile-search-drawer");
  const openBtn = document.querySelector(".br-mobile-search-toggle");

  if (drawer) {
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
  }

  if (openBtn) {
    openBtn.setAttribute("aria-expanded", "false");
  }

  document.documentElement.classList.remove("br-search-open");
}



window.closeVisualResults = closeVisualResults;
window.backToVisualUpload = backToVisualUpload;
window.openVisualSearch = openVisualSearch;
window.closeUploadBox = closeUploadBox;
window.previewImageSearch = previewImageSearch;
window.closeCropModal = closeCropModal;
window.searchCroppedImage = searchCroppedImage;
window.handleImageFile = handleImageFile;
window.openMobileCamera = openMobileCamera;
window.closeMobileCamera = closeMobileCamera;